import React, {Component} from 'react';
import {connect} from 'react-redux';
// style
import style from '../css/accumulatorBoostScreen.css';
// helpers
import {getText} from '../../../helpers/localization';
// identifiers
// actions
// configurations
import {OPERATOR} from '../../../constants/operator';
import {getAccaBetName} from "../modules/matchday/helpers/matchdayHelper";

const mapStateToProps = (state, ownProps) => {
    return {
        isModalOpen: state.vpp.isModalOpen,
        openModalType: state.vpp.openModalType,
        selectedOddsType: state.vpp.selectedOddsType,
        systemLanguage: state.vpp.systemLanguage,
        isVideoVisible: state.vpp.isVideoVisible
    };
};

class AccumulatorBoostScreen extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;

    }

    render() {
        let store = this.props.store;
        let accaPrizeBoost = JSON.parse(OPERATOR.accaBoostBonusPercentage);
        let maxAccaPrice = Object.entries(accaPrizeBoost).sort((x, y) => y[1] - x[1])[0]
        let minAccaPrice = Object.entries(accaPrizeBoost).sort((x, y) => x[1] - y[1])[0]
        let betType = (<span>{getText('BET_TYPE', store)}</span>)
        let boost = (<span>{getText('BOOST', store)}</span>)
        let accaTable = (
            <table className={style.tableStyle}>
                <tbody>
                <tr>
                    <th>{betType}</th>
                    <th>{boost}</th>
                </tr>
                {
                    Object.keys(accaPrizeBoost).map((key, i) => (
                        <tr key={i}>
                            <td><span> {getText('1', store) + ' ' + getText('x', store) + ' '}</span>
                                <span>{getAccaBetName(parseInt(key), this.props.store)}</span></td>
                            <td>
                                <div>{getText('BOOST_PERCENTAGE', store, [accaPrizeBoost[key]])}</div>
                            </td>
                        </tr>
                    ))
                }
                </tbody>
            </table>

        )
        let accumulatorInfo = (<div className={style.content}>{getText('ACCUMULATOR_INFO', store,
            [minAccaPrice !== undefined && minAccaPrice.length > 0 ? minAccaPrice[1] : '0', maxAccaPrice !== undefined && maxAccaPrice.length > 0 ? maxAccaPrice[1] : '0'])}</div>)
        return (
            <div className={style.accumulatorBoost}>
                <div className={style.title}>{getText('ACCUMULATOR_BOOST', this.props.store)}</div>
                {accumulatorInfo}
                {accaTable}
            </div>
        );
    }
}

export default connect(mapStateToProps)(AccumulatorBoostScreen);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/accumulatorboostScreen.js